var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.257,
    height: 16.2,
    viewBox: "0 0 27.257 16.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(-11.025 -110.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(11.025 110.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M38.194,118.211a15.643,15.643,0,0,0-27.082,0,.521.521,0,0,0,0,.579,15.643,15.643,0,0,0,27.082,0A.521.521,0,0,0,38.194,118.211Zm-13.541,7.232A14.471,14.471,0,0,1,12.325,118.5a14.416,14.416,0,0,1,24.656,0A14.471,14.471,0,0,1,24.653,125.443Z",
    transform: "translate(-11.025 -110.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M167.607,162.4a5.207,5.207,0,1,0,5.207,5.207A5.185,5.185,0,0,0,167.607,162.4Zm0,9.257a4.05,4.05,0,1,1,4.05-4.05A4.026,4.026,0,0,1,167.607,171.657Z",
    transform: "translate(-153.979 -159.507)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.db036d58bc2a071dcbe52f579bd619ec.svg";
export { ForwardRef as ReactComponent };